// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"296":"8ecc3682","325":"370eee90"}[chunkId] + ".chunk.js";
};